const types = {
  CREATE_NEW_BOARD: 'CREATE_NEW_BOARD',
  CREATE_NEW_BOARD_SUCCESS: 'CREATE_NEW_BOARD_SUCCESS',
  CREATE_BOARD_FAILED: 'CREATE_BOARD_FAILED',
  GET_USER_BOARDS: 'GET_USER_BOARDS',
  GET_USER_BOARDS_SUCCESS: 'GET_USER_BOARDS_SUCCESS',
  GET_USER_BOARDS_FAILED: 'GET_USER_BOARDS_FAILED',
  DELETE_BOARD: 'DELETE_BOARD',
  DELETE_BOARD_SUCCESS: 'DELETE_BOARD_SUCCESS',
  DELETE_BOARD_FAILED: 'DELETE_BOARD_FAILED',
  INVITE_USER_ON_BOARD: 'INVITE_USER_ON_BOARD',
  INVITE_USER_ON_BOARD_SUCCESS: 'INVITE_USER_ON_BOARD_SUCCESS',
  INVITE_USER_ON_BOARD_FAILED: 'INVITE_USER_ON_BOARD_FAILED',
  GET_BOARD_USERS: 'GET_BOARD_USERS',
}

export default types;
